const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');

// @commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const OKTooltip = require('commonsComponents/OKTooltip');

// @components
const { LoadingSection } = require('commonsComponents/loadingSection');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @actions
const BrokerPlanLegalDocumentActions = require('actions/brokerPlanLegalDocument');

class BrokerPlanLegalDocumentDisclaimer extends React.Component {
    constructor(props) {
        super(props);

        this.buildDisclaimerCheckboxLabel = this.buildDisclaimerCheckboxLabel.bind(this);
    }

    componentWillMount() {
        this.props.fetchLegalDocuments(this.props.planDgsCode, this.props.planSecId);
    }

    buildDisclaimerCheckboxLabel() {
        const { isAportation } = this.props;
        const planNameLabel = <span>{this.props.planName}</span>;
        const fundamentalPlanDataLink = <FormattedText value="planLegalDocumentDisclaimer-fundamentalPlanData"/>
        const specificationsLink = <FormattedText value="planLegalDocumentDisclaimer-specifications"/>
        if (isAportation) {
            return (
                <FormattedTextWithComponents
                    value="planLegalDocumentDisclaimer-aportDisclaimer"
                    injectedComponents={[
                        fundamentalPlanDataLink,
                        planNameLabel,
                        specificationsLink
                    ]}
                />
            );
        } else {
            const subscriptionNewsletterLink = <FormattedText value="planLegalDocumentDisclaimer-subscriptionNewsletter"/>
            const contractProvisionServicesNaturalPersonsLink = <FormattedText value="planLegalDocumentDisclaimer-contractProvisionServicesNaturalPersons"/>
            return (
                <FormattedTextWithComponents
                    injectedComponents={[
                        fundamentalPlanDataLink,
                        planNameLabel,
                        specificationsLink,
                        subscriptionNewsletterLink,
                        contractProvisionServicesNaturalPersonsLink
                    ]}
                    value="planLegalDocumentDisclaimer-disclaimer"
                />
            );
        }
    }

    render() {
        const {
            immBrokerPlanLegalDocument,
            disclaimerChecked,
            onDisclaimerCheckChange,
            disclaimerErrorState,
            disclaimerErrorMessage
        } = this.props;

        if (immBrokerPlanLegalDocument.get('isFetching')) {
            return <LoadingSection/>;
        } else {
            if (disclaimerChecked) {
                return (
                    <OKCheckbox
                        idName="plan-legal-document-disclaimer-checkbox"
                        label={this.buildDisclaimerCheckboxLabel()}
                        onChange={onDisclaimerCheckChange}
                        errorState={disclaimerErrorState}
                        errorMessage={disclaimerErrorMessage}
                        value={disclaimerChecked}
                    />
                );
            }
            else {
                return (
                    <OKTooltip
                        content={<FormattedText value={'planLegalDocumentDisclaimer-warningTooltip'}/>}
                        placement={'topLeft'}
                        offset={[-50, -5]}
                        target={
                            <div>
                                <OKCheckbox
                                    idName="plan-legal-document-disclaimer-checkbox"
                                    label={this.buildDisclaimerCheckboxLabel()}
                                    onChange={onDisclaimerCheckChange}
                                    errorState={disclaimerErrorState}
                                    errorMessage={disclaimerErrorMessage}
                                    value={disclaimerChecked}
                                />
                            </div>
                        } />
                );
            }
        }
    }
}

BrokerPlanLegalDocumentDisclaimer.propTypes = {
    disclaimerErrorState: PropTypes.bool.isRequired,
    disclaimerErrorMessage: PropTypes.string.isRequired,
    disclaimerChecked: PropTypes.bool.isRequired,
    onDisclaimerCheckChange: PropTypes.func.isRequired,
    planName: PropTypes.string.isRequired,
    planDgsCode: PropTypes.string.isRequired,
    planSecId: PropTypes.string.isRequired,
    immBrokerPlanLegalDocument: PropTypes.object.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    isAportation: PropTypes.bool,
};

module.exports.constructor = BrokerPlanLegalDocumentDisclaimer;
module.exports.BrokerPlanLegalDocumentDisclaimer = connect(
    state => ({
        immBrokerPlanLegalDocument: state.brokerPlanLegalDocument
    }),
    {
        fetchLegalDocuments: BrokerPlanLegalDocumentActions.fetchLegalDocuments
    }
)(BrokerPlanLegalDocumentDisclaimer);
